<template>
  <v-list two-line>
    <div v-for="(ticket, index) in list" :key="'ticket_search_'+index">
      <v-divider
          v-if="index > 0"
          :key="'ticket_search_line_'+index"
      ></v-divider>
      <v-list-item
          dense
          :key="'ticket_search_item_'+index"
          :to="{name: 'ticket', params: {id: ticket.ticket.uid}}"
          exact
      >
        <v-list-item-content>
          <v-list-item-title>Запрос № {{ ticket.ticket.id }} / {{ ticket.ticket.name }}</v-list-item-title>
          <v-list-item-subtitle v-text="ticket.message"/>
        </v-list-item-content>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
export default {
  name: 'SearchResult',
  props: ['list'],
  data: () => ({

  }),
}
</script>